import { combineSlices } from "@reduxjs/toolkit";

import { documentViewerSlice } from "./documentViewerSlice";

export default combineSlices(documentViewerSlice);
